var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('g',[_c('circle',{attrs:{"cx":_vm.px,"cy":_vm.py,"r":_vm.radius * _vm.shadow,"fill":_vm.color}}),_c('circle',{attrs:{"cx":_vm.px,"cy":_vm.py,"r":_vm.radius,"fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }